import { useEffect, useState } from "react";

import NumberFlow, { NumberFlowGroup } from "@number-flow/react";

interface Props {
	seconds: number;
}

export default function Countdown({ seconds }: Props) {
	const [timeLeft, setTimeLeft] = useState(seconds);

	useEffect(() => {
		const timer = setInterval(() => {
			setTimeLeft(timeLeft > 0 ? timeLeft - 1 : 0);
		}, 1000);

		return () => clearInterval(timer);
	}, [timeLeft]);

	const hh = Math.floor(timeLeft / 3600);
	const mm = Math.floor((timeLeft % 3600) / 60);
	const ss = timeLeft % 60;
	return (
		<NumberFlowGroup>
			<div
				style={{ fontVariantNumeric: "tabular-nums", ["--number-flow-char-height" as string]: "0.85em" }}
				className="text-3xl/4xl flex items-baseline font-medium"
			>
				<NumberFlow trend={-1} value={hh} format={{ minimumIntegerDigits: 2 }} />
				<NumberFlow
					prefix=":"
					trend={-1}
					value={mm}
					digits={{ 1: { max: 5 } }}
					format={{ minimumIntegerDigits: 2 }}
				/>
				<NumberFlow
					prefix=":"
					trend={-1}
					value={ss}
					digits={{ 1: { max: 5 } }}
					format={{ minimumIntegerDigits: 2 }}
				/>
			</div>
		</NumberFlowGroup>
	);
}
